module.exports = __webpack_public_path__ + "static/media/square-root-alt.7174b28b.svg";